<template>
    <main>  <b-button class="ml-2 mt-5" size="sm" variant="outline-dark" @click="toggleShowHatchCover">
                    َBack
                 </b-button>
        <div class="d-flex">
          
            <div class="bay-view col-smflex justify-content-center  p-1 py-5">
                <h3 v-if="false" class="text-center">Bay {{ String(name).padStart(2, '0') }}</h3>
                <bay-on-deck style="justify-items: center;" :rel="this.rel" :data="data.onDeck" :minDeckTiers="data.minDeckTiers"
                    :mirrorMode="mirrorMode" :selectedContainerType="selectedContainerType" />
                    <HatchCover style="justify-items: center;" ref="hatchCoverComponent" :cellSize="10"
                    :vesselProfileHatchCovers="this.selectedHatchDatas.vesselProfileHatchCovers"
                    :cellsCount="this.selectedHatchDatas.cellsCount" v-if="this.selectedHatchData.cellsCount" />
                 <bay-under-deck style="justify-items: center;"  :rel="this.rel" :data="data.underDeck" :minHoldTiers="data.minHoldTiers" :mirrorMode="mirrorMode"
                    :selectedContainerType="selectedContainerType" /> 
            </div>
            <div class="w-16 mb-5">
                <!-- <app-button @click="AddHatchCovers">
                    <v-icon class="fa fa-plus"></v-icon>
                    <span class="hideButtonTitle"> Add HatchCovers</span>
                </app-button> -->
                <div class="mb-5">
                    <div class="mt-10">
                        <div class="d-flex align-items-center mt-4" v-for="hc in vesselProfileHatchCoversArray">
                            <v-text-field @focus="$event.target.select()" dense outlined class="ml-5 w-10"
                                v-model="hc.coverName" va hide-details="auto"></v-text-field>
                                <v-icon style="color: red;"  class="ml-2 fa fa-trash" @click="deleteCover(hc.coverName)"></v-icon>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </main>
</template>

<script>
import BayOnDeck from '@/view/pages/vesselProfile/components/HatchCovers/BayOnDeckHatchCovers.vue'
import BayUnderDeck from '@/view/pages/vesselProfile/components/HatchCovers/BayUnderDeckHatchCovers.vue'
import HatchCover from '@/components/HatchCover.vue'
import { mapGetters,mapActions } from 'vuex'
import AppButton from "@/components/AppButton.vue"


export default {

    props: {
        name: {
            type: Number,
            default: 1
        },
        selectedContainerType: {
            default: 'standard'
        },
        mirrorMode: {
            default: false
        },
        data: {
            default: {
                minHoldTiers: 0,
                minDeckTiers: 0,               
                onDeck: {
                    cols: 4,
                    rows: 4,
                    cells: [{ existed: true, isReefer: false, is45Foot: false }, { existed: true, isReefer: false, is45Foot: false }, { existed: true, isReefer: false, is45Foot: false }, { existed: true, isReefer: false, is45Foot: false }, { existed: true, isReefer: false, is45Foot: false }, { existed: true, isReefer: false, is45Foot: false }, { existed: true, isReefer: false, is45Foot: false }, { existed: true, isReefer: false, is45Foot: false }, { existed: true, isReefer: false, is45Foot: false }, { existed: true, isReefer: false, is45Foot: false }, { existed: true, isReefer: false, is45Foot: false }, { existed: true, isReefer: false, is45Foot: false }, { existed: true, isReefer: false, is45Foot: false }, { existed: true, isReefer: false, is45Foot: false }, { existed: true, isReefer: false, is45Foot: false }],
                },
                underDeck: {
                    cols: 4,
                    rows: 4,
                    cells: [{ existed: true, isReefer: false, is45Foot: false }, { existed: true, isReefer: false, is45Foot: false }, { existed: true, isReefer: false, is45Foot: false }, { existed: true, isReefer: false, is45Foot: false }, { existed: true, isReefer: false, is45Foot: false }, { existed: true, isReefer: false, is45Foot: false }, { existed: true, isReefer: false, is45Foot: false }, { existed: true, isReefer: false, is45Foot: false }, { existed: true, isReefer: false, is45Foot: false }, { existed: true, isReefer: false, is45Foot: false }, { existed: true, isReefer: false, is45Foot: false }, { existed: true, isReefer: false, is45Foot: false }, { existed: true, isReefer: false, is45Foot: false }, { existed: true, isReefer: false, is45Foot: false }, { existed: true, isReefer: false, is45Foot: false }],
                }
            }
        },
        rel: {
            default: ''
        },
    },
    data() {
        return {
            v: this.selectedHatchData.vesselProfileHatchCovers
        }
    },
    methods: {
        ...mapActions({
            setSelectedHatchData: 'setSelectedHatchData'
        }),
        toggleShowHatchCover(){
            this.$store.dispatch('setShowHatchCover', {  })
        },
        deleteCover(name){
            var index = this.selectedHatchData.vesselProfileHatchCovers.findIndex(c=>c.coverName == name)
            this.$refs.hatchCoverComponent.ResetCells(this.selectedHatchData.vesselProfileHatchCovers[index]);
            this.selectedHatchData.vesselProfileHatchCovers.splice(index, 1)
        },
        AddHatchCovers() {
            this.setSelectedHatchData({
                vesselProfileHatchCovers: [{
                    coverName: "string2",
                    startCell: 12,
                    endCell: 16
                }]
            })
        }
    },
    computed: {
        ...mapGetters({
            selectedHatchData: 'getSelectedHatchData'
        }),
        selectedHatchDatas() {
            return this.selectedHatchData;
        },

        vesselProfileHatchCoversArray(){
         let myObject = Object.assign({}, this.selectedHatchData.vesselProfileHatchCovers);
         return myObject;
        },

        isBayMirrored: {
            get() {
                return this.$store.state.vesselProfile.mirroredBays[this.rel]
            },
            set() {
                this.isMirrored = !this.isMirrored
                this.$store.dispatch('setMirroredBays', { [this.rel]: this.isMirrored })
                return this.isMirrored
            }
        },
    },
    components: {
        BayOnDeck,
        BayUnderDeck,
        HatchCover,
        AppButton
    },
}

</script>
<style scoped></style>